import { render, staticRenderFns } from "./wsRightSidebarContent.vue?vue&type=template&id=4b5558cf&scoped=true&"
import script from "./wsRightSidebarContent.vue?vue&type=script&lang=js&"
export * from "./wsRightSidebarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5558cf",
  null
  
)

export default component.exports